import { useState } from "react";
import { getUno } from "../../../api/apis";

export const useDatosTallas = () => {
  const [tallas, setTallas] = useState([]);


  const getTallas = async () => {
    const tallas = await getUno('tallas', {});
    const tallasFormateadas = tallas.data.data.reduce((acc, { prenda, tallas, label }) => ({ ...acc, [prenda]: tallas }), {});

    setTallas(tallasFormateadas);
  }

  const validateTallas = (obj, seleccionableTalla) => {
    let errObj = {};
    const { talla_pantalon, talla_polera, talla_camisablusa, talla_poleron, talla_chaqueta } = obj;

    if (seleccionableTalla) {
      if (!talla_pantalon) { errObj.talla_pantalon = "Requerido"; }
      if (!talla_polera) { errObj.talla_polera = "Requerido"; }
      if (!talla_camisablusa) { errObj.talla_camisablusa = "Requerido"; }
      if (!talla_poleron) { errObj.talla_poleron = "Requerido"; }
      if (!talla_chaqueta) { errObj.talla_chaqueta = "Requerido"; }
    }

    return errObj;
  };

  return { getTallas, validateTallas, tallas };
};
